import { render, staticRenderFns } from "./SelectForeign.vue?vue&type=template&id=4ce877b8&scoped=true"
import script from "./SelectForeign.vue?vue&type=script&lang=js"
export * from "./SelectForeign.vue?vue&type=script&lang=js"
import style0 from "./SelectForeign.vue?vue&type=style&index=0&id=4ce877b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ce877b8",
  null
  
)

export default component.exports